import React from "react";
import { Oval } from "react-loader-spinner";
import { BarLoader, BeatLoader, HashLoader, PuffLoader } from "react-spinners";

const color = "#07bc0c";
export const OvalSpinner = () => {
  return (
    <Oval
      height={25}
      width={25}
      color={color}
      secondaryColor={color}
      strokeWidth={10}
      strokeWidthSecondary={8}
    />
  );
};

export const BarLoading = () => {
  return <BarLoader color={color} />;
};

export const HashLoading = () => {
  return <HashLoader color={color} size={20} />;
};

export const BeatLoading = () => {
  return <BeatLoader color={color} size={6} />;
};

export const PuffLoading = () => {
  return <PuffLoader color="#002677" size={60} speedMultiplier={0.8} />;
};
